import { Navigate, useLocation } from 'react-router-dom';
import { readLastPage, useLastPageScope } from './last-visited-page';

/** Explicit bookmarks win; otherwise resume the current person's entity location. */
export function StaffLandingRoute() {
  const { search, hash } = useLocation();
  const { key, access } = useLastPageScope();
  if (access.status === 'loading' || access.status === 'switching' || access.status === 'idle') {
    return <div role="status">Loading your last page…</div>;
  }
  if (search || hash) {
    const destination = new URLSearchParams(search).has('view') ? '/overview' : '/agent';
    return <Navigate to={`${destination}${search}${hash}`} replace />;
  }
  return <Navigate to={readLastPage(key, access) ?? '/agent'} replace />;
}
